import React, { FunctionComponent } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import { useQuery } from "@tanstack/react-query";
// import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { fetch_all_with_count, fetch_all } from "../../lib/v31lib";
// import { loginAtom } from '../../../lib/auth';

// import Lenis from "lenis";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { gsap } from "gsap";

import {
  Box,
  Grid,
} from '@mui/material';
// import {
//   WhiteSection
// } from '../../../components/v2/custom';
import {
  DarkGreenButton,
  TextButton,
  TextInput,
  Typography
} from '../../../components/v2/styled';
import { ErrorBox } from '../../../components/v2/styled/ErrorBox';

// import { Benefit as Ben } from '../../models/Benefit';
// import { NewsItem as NI } from '../../models/NewsItem';
// import { User, loginFields } from '../../models/User';

// const { DateTime } = require("luxon");

type Props = {
  username?: string;
  setUsername: (s:string) => void;
  password?: string;
  setPassword: (s:string) => void;
  passwordRepeat?: string;
  setPasswordRepeat: (s:string) => void;
  existing?: boolean;
  message?: string;
  onBack: () => void;
  onSubmit: () => void;
}

export const FirstTimeCredentials: FunctionComponent<Props> = ({username, setUsername, password, setPassword, passwordRepeat, setPasswordRepeat, existing, message, onBack, onSubmit}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);







  
  return <>
    <Grid item xs={12} sx={{textAlign: 'center'}}>
      <Typography variant="h1" sx={{
        marginTop: 4,
        display: 'inline-block',
        maxWidth: {
          xs: '100%',
          lg: '440px'
        }
      }}>{t("nw.register.hero.title_credentials")}</Typography>
    </Grid>
    <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
      <Typography variant="subtitle1" html fuck_p_tags sx={{
        display: 'inline-block',
        maxWidth: {
          xs: '100%',
          lg: '440px'
        }
      }}>{t("nw.register.hero.subsection_credentials")}</Typography>
    </Grid>

    <Grid item xs={12} sx={{textAlign: 'center'}}>
      <Box sx={{
        display: 'inline-block',
        width: {
          xs: '100%',
          lg: '440px'
        },
        textAlign: 'left'
      }}>
        <TextInput
          value={username || ''}
          onChange={(v) => {
            setUsername(v);
          }}
          starred
          caption={t("nw.register.form.username")}
          // placeholder={t("nw.contact.form.placeholder.first_name")}
          sx={{
            borderRadius: "8px",
            width: '100%',
            border: "2px solid transparent",
            borderColor: theme.palette.primary.dark,
            paddingTop: 0.25,
            paddingBottom: 0.25,
            height: '40px',
            backgroundColor: 'transparent',
          }}
        />
      </Box>
    </Grid>
    <Grid item xs={12} sx={{textAlign: 'center'}}>
      <Box sx={{
        display: 'inline-block',
        width: {
          xs: '100%',
          lg: '440px'
        },
        textAlign: 'left'
      }}>
        <TextInput
          value={password || ''}
          onChange={(v) => {
            setPassword(v);
          }}
          starred
          type="password"
          caption={t("nw.register.form.password")}
          // placeholder={t("nw.contact.form.placeholder.first_name")}
          sx={{
            borderRadius: "8px",
            width: '100%',
            border: "2px solid transparent",
            borderColor: theme.palette.primary.dark,
            paddingTop: 0.25,
            paddingBottom: 0.25,
            height: '40px',
            backgroundColor: 'transparent',
          }}
        />
      </Box>
    </Grid>
    <Grid item xs={12} sx={{textAlign: 'center'}}>
      <Box sx={{
        display: 'inline-block',
        width: {
          xs: '100%',
          lg: '440px'
        },
        textAlign: 'left'
      }}>
        <TextInput
          value={passwordRepeat || ''}
          onChange={(v) => {
            setPasswordRepeat(v);
          }}
          starred
          type="password"
          caption={t("nw.register.form.password_repeat")}
          // placeholder={t("nw.contact.form.placeholder.first_name")}
          sx={{
            borderRadius: "8px",
            width: '100%',
            border: "2px solid transparent",
            borderColor: theme.palette.primary.dark,
            paddingTop: 0.25,
            paddingBottom: 0.25,
            height: '40px',
            backgroundColor: 'transparent',
          }}
        />
      </Box>
    </Grid>
    {!!existing && <Grid item xs={12} sx={{textAlign: 'center'}}>
      <ErrorBox
        type="error"
        text={t("nw.register.hero.subsection_uniq_error")}
      />
    </Grid>}
    {!existing && !!message && <Grid item xs={12} sx={{textAlign: 'center'}}>
      <ErrorBox
        type="error"
        text={t("nw.register.hero.subsection_general_error")}
      />
    </Grid>}

    <Grid item xs={12} sx={{textAlign: 'right', marginBottom: 8}}>
      <Box sx={{
        display: 'block',
        width: '100%',
        maxWidth: {
          xs: '100%',
          lg: '440px'
        },
        marginTop: 2,
        marginRight: 'auto',
        marginLeft: 'auto',
        textAlign: 'right'
      }}>
        <Box sx={{
          display: 'inline-block',
          width: {
            xs: '100%',
            lg: '49%'
          },
          textAlign: 'left',
          float: 'left'
        }}>
          <TextButton
            label={t("nw.register.hero.cta_back")}
            id="sub_btn"
            onClick={() => {
              onBack();
            }}
            sx={{
              marginBottom: 1,
              color: theme.palette.primary.dark,
              textDecoration: 'underline',
              "&:hover": {
                color: theme.palette.primary.light,
                backgroundColor: 'transparent'
              },
              paddingLeft: 0,
              paddingRight: 0
            }}
          />
        </Box>
        <Box sx={{
          display: 'inline-block',
          width: {
            xs: '100%',
            lg: '49%'
          },
          marginLeft: 'auto',
          textAlign: 'right'
        }}>
          <DarkGreenButton
            label={t("nw.register.hero.cta")}
            id="sub_btn"
            sx={{
              marginBottom: 1,
              borderColor: theme.palette.primary.dark,
              "&:hover": {
                borderColor: theme.palette.primary.dark,
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.primary.dark,
              },
              "&.Mui-disabled": {
                color: 'grey',
              },
            }}
            disabled={!username || !password || !passwordRepeat || password !== passwordRepeat || !!existing}
            onClick={() => {
              onSubmit();
            }}
          />
        </Box>
      </Box>
    </Grid>
  </>;
}

